import { Box, IconButton, Typography, styled } from '@mui/material';

export const StyledRecorder = styled(Box)(() => ({
  display: 'grid',
  gridTemplate: `'. button time'`,
  gridTemplateColumns: '30% 1fr 30%',
  alignItems: 'center',
  width: '100%',
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  gridArea: 'button',
  justifySelf: 'center',
  borderRadius: theme.spacing(0.5),
}));

export const StyledRecordButton = styled(StyledIconButton)(({ theme }) => ({
  color: theme.palette.grey[800],
  background: theme.palette.error.light,
  '&:hover': {
    background: theme.palette.error.main,
  },
  '&.Mui-disabled': {
    background: theme.palette.grey[200],
    color: theme.palette.grey[300],
  },
}));

export const StyledStopButton = styled(StyledIconButton)(({ theme }) => ({
  background: theme.palette.grey[400],
  '&:hover': {
    background: theme.palette.grey[500],
  },
}));

export const StyledTime = styled(Typography)(() => ({
  gridArea: 'time',
  justifySelf: 'end',
}));
